export const GET_MAINTENANCENOTIFICATION = "GET_MAINTENANCENOTIFICATION";
export const CLEAR_MAINTENANCENOTIFICATION = "CLEAR_MAINTENANCENOTIFICATION";

export const GET_CARD_BALANCE = "GET_CARD_BALANCE";
export const UNSET_CARD_BALANCE = "UNSET_CARD_BALANCE";

export const UNSET_PERSONAL_DATA = "UNSET_PERSONAL_DATA";

export const SET_UPCOMING_LEAVES = "SET_UPCOMING_LEAVES";

